import { useMemo } from "react";
import { MESHCORE_ROLE_LABEL, normalizeMeshCoreRole } from "../lib/definitions/protocols";
import { formatLocalDateTime } from "../lib/format";
import { EVIDENCE_TEXT, linkCountText, type GraphModel, type VisibleGraph } from "../lib/neighbourGraph";

// The hover card of the Neighbour graph tab, shared by the graph layout and the map layout: the node's name, role and
// link count, and its five strongest shown links.
export function NodeTip({ model, vis, idx }: { model: GraphModel; vis: VisibleGraph; idx: number }) {
  const links = useMemo(
    () => vis.edges.filter((e) => e.a === idx || e.b === idx).sort((a, b) => b.count - a.count).slice(0, 5),
    [vis, idx],
  );
  const node = model.nodes[idx];
  return (
    <>
      <div className="ng-tip-name">{node.name}</div>
      <div className="ng-muted">
        {MESHCORE_ROLE_LABEL[normalizeMeshCoreRole(node.role)]}, {linkCountText(vis.degree[idx], node.links)}
      </div>
      {links.map((e) => {
        const other = e.a === idx ? e.b : e.a;
        return (
          <div key={other} className="ng-tip-link" title={EVIDENCE_TEXT[e.evidence]}>
            {model.nodes[other].name}: seen {e.count.toLocaleString("en-US")} times
            {e.bothWays ? ", both ways" : ""}
            {e.lastSeen ? `, last ${formatLocalDateTime(e.lastSeen)}` : ""}
          </div>
        );
      })}
    </>
  );
}
